import React from "react";
import {sendReactRenderError} from "@common/helpers/installGlobalErrorReporter";

export default class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    componentDidCatch(error, info) {
        this.setState({ hasError: true });
        sendReactRenderError({
            message: error?.message,
            stack: error?.stack,
            componentStack: info?.componentStack,
        });
    }

    render() {
        if (this.state.hasError) {
            return <div className="critical-error">
                <h4>Something went wrong</h4>
            </div>;
        }

        return this.props.children;
    }
}